import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { FormattedMessage } from "react-intl";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import humanImage from "../../assets/img/human.svg";
import macImage from "../../assets/img/mac.svg";
import tsPayBackground from "../../assets/img/background-tspay-banner.svg";

import { TSDIGITAL_PORTALE_PUBLIC_URL } from "../../config";
import "./style.css";
import { Button } from "@ts-digital/vrc";
import { useSelector } from "react-redux";

const LandingNoPay = () => {  

  const location = useLocation();
  const navigate = useNavigate();
  const main = useSelector(state => state.main);

  let fromToast = false;
  if (location.state) {
    if (state.fromToast) {
      fromToast = true;
    }
  }

  const linkBack = {
    text: <FormattedMessage id="deadlines.goClientList" />,
    pushUrl: "/scheda-cliente",
    winLocation: null
  };

  let linkHref = "https://digital.teamsystem.com/lp-richiedi-info-ts-digital?partita_iva_forms=" + main.accountantIdSelected + "&prodotti_ts_digital=ts-pay";
  let buttonTextId = "customerPage.landing.contactUs";
  if (fromToast) {
    linkHref = TSDIGITAL_PORTALE_PUBLIC_URL +
    "#/" +
    main.accountantIdSelected +
    "/connections/create/existingCompany/" +
    main.clientIdSelected;
    buttonTextId = "customerPage.landing.tsPayConnectionsButton";
  }

  return (
    <div className="containerDiv">
      <div style={{backgroundImage: `url(${tsPayBackground})`, height:"422px"}}>
        <div
          className="backTo"
          onClick={el => {
            navigate(linkBack.pushUrl);
          }}
        >
          <FontAwesomeIcon icon={["fal", "arrow-left"]} />{" "}
          <span>{linkBack.text}</span>
        </div>
        <div style={{ display: "flex",flexDirection: "column" }}>
          <div className="headContainerLandingTSPay">
            <div className="headerTsPayContainer">
              <img  style={{width:"265px", height:"376px", marginTop:"7px", marginLeft: "280px"}} src={humanImage} alt="" />
            </div>
            <div style={{width:"710px"}}>
              <div style={{marginBottom: "20px"}} className="noTSPayTitle">
                <FormattedMessage id="customerPage.landing.noTSPayTitleUp" />
              </div>
              <div className="noTSPaySub">
                <FormattedMessage id="customerPage.landing.noTSPaySubTitleUp" />
              </div>
              <div style={{marginTop: "30px"}} className="buttonPack">
                <a
                  href={linkHref}
                  id="goToTSDigital"
                  tabIndex="0"
                >
                  <Button
                    className="buttonNoTsPay"
                    style={{ marginRight: "20px", color: "white", borderColor:"white", borderRadius: "2px", border: "1px solid rgb(255, 255, 255)"}}
                    kind="secondary"
                    colorScheme="ghost"
                  >
                    <FormattedMessage id={buttonTextId} />
                  </Button>
                </a>
              </div>
            </div>

          </div>
        </div>
      </div>
      <div className="middleDiv">
        <div className="imgContainer">
          <img src={macImage} alt=""/>
        </div>
        <div className="textContainer">
          <div className="middleTitle">
            <FormattedMessage id="customerPage.landing.titleMiddleTSPay1" /><br></br><FormattedMessage id="customerPage.landing.titleMiddleTSPay2" />
          </div>
          <div className="middleSub">
            <FormattedMessage id="customerPage.landing.subTitleMiddle1TSPay" />
          </div>
          <div className="middleSub">
            <FormattedMessage id="customerPage.landing.subTitleMiddle2TSPay1" /><br></br><br></br><FormattedMessage id="customerPage.landing.subTitleMiddle2TSPay2" /><br></br><br></br><FormattedMessage id="customerPage.landing.subTitleMiddle2TSPay3" />
          </div>
        </div>
      </div>
      <div className="bottomDiv">
        <div className="bottomTitleText"><FormattedMessage id="customerPage.landing.bottomText" /></div>
        <div className="bottomItems">
          <FontAwesomeIcon icon={["far", "link"]} className="iconCss" />{" "}
          <FontAwesomeIcon icon={["far", "university"]} className="iconCss" />{" "}
          <FontAwesomeIcon icon={["far", "tachometer"]} className="iconCss" />{" "}
        </div>
        <div className="bottomItems">
          <div className="bottomText bold">
            <FormattedMessage id="customerPage.landing.doPaymentTitle" />
          </div>
          <div className="bottomText bold">
            <FormattedMessage id="customerPage.landing.reconciliationTitle" />
          </div>
          <div className="bottomText bold">
            <FormattedMessage id="customerPage.landing.cashFlowTitle" />
          </div>
        </div>
        <div className="bottomItems">
          <div className="bottomText">
            <FormattedMessage id="customerPage.landing.doPaymentSub" />
          </div>
          <div className="bottomText">
            <FormattedMessage id="customerPage.landing.reconciliationSub" />
          </div>
          <div className="bottomText">
            <FormattedMessage id="customerPage.landing.cashFlowSub" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default LandingNoPay;
